import { Suspense, lazy } from "react"
import { Navigate, Route, BrowserRouter as Router, Routes, Outlet, useLocation } from "react-router-dom"

import queryString from "query-string"
import { QueryParamProvider } from "use-query-params"
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6"

import { routes } from "../routes/routes"
import Auth from "../utils/auth"
// Eagerly-loaded dashboard shell (children inside are lazy-loaded)
import Dashboard from "./Dashboard/Dashboard"
import LoadingScreen from "./Dashboard/components/LoadingScreen"

// Lazy-loaded login screen
const Login = lazy(() => import("./Login/Login"))

function PrivateRoute() {
  const isAuthenticated = Auth.isAuthenticated()
  const location = useLocation()

  return isAuthenticated ? <Outlet /> : <Navigate to={{ pathname: "/login" }} state={{ from: location }} />
}

function App() {
  return (
    <Router>
      <QueryParamProvider
        adapter={ReactRouter6Adapter}
        options={{
          searchStringToObject: queryString.parse,
          objectToSearchString: queryString.stringify,
        }}
      >
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path="*" element={<Dashboard />} />
          </Route>

          <Route
            path="/login"
            element={
              <Suspense fallback={<LoadingScreen isLoading />}>
                <Login redirectPath={`/${routes?.home}`} />
              </Suspense>
            }
          />
        </Routes>
      </QueryParamProvider>
    </Router>
  )
}

export default App
